import {
  callIfFn,
  EntityPlacerBuilder,
  plannerHistoryHelper
} from "src/components/Planner/planner/history";
import { PlannerAction } from "src/components/Planner/planner/history/planner-action";
import {ts} from "src/utils/translate"
import {
  redrawRooms
} from "src/components/Planner/planner/planner";
import { PlannerGlobals } from "src/components/Planner/planner/planner-globals";
import {redrawDevices} from "src/components/Planner/planner/deviceDrawing";
import {
  deleteOuterWalls,
  saveOuterWalls
} from "src/components/Planner/planner/outerwall";

/* OUTER WALL START */
export class CreateOuterWallsAction extends PlannerAction {
  /**
   *
   * @param {PolyPoint[]} outerBorder
   */
  constructor(outerBorder, matSaveState) {
    super();
    this.outerBorder = outerBorder;
    this.actionName = ts("p_do_action_outer_new", "Creating outer walls");
    this.matSaveState = matSaveState;
  }
  execute(callback) {
    const thisVar = this;
    saveOuterWalls(this.outerBorder, function () {
      PlannerGlobals.wallSegmentation.recalcPreserveSave(thisVar.matSaveState, true);

      new EntityPlacerBuilder()
      .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
      .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));

      // callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    const thisVar = this;
    deleteOuterWalls(function () {
      redrawRooms();
      redrawDevices();

      new EntityPlacerBuilder()
      .setMatSaveState(thisVar.matSaveState)
      .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));

      /* callIfFn(callback, true); */
    }, function () {
      callIfFn(callback, false);
    });
  }
}
export class ModifyOuterWallsAction extends PlannerAction {
  /**
   *
   * @param {PolyPoint[]} fromWalls
   * @param {PolyPoint[]} toWalls
   * @param {D3Device[]} d3Devs
   * @param {Group[]} groups
   * @param {SerialConnection[]} serialConnections
   */
  constructor(fromWalls, toWalls, d3Devs, groups, matSaveState, serialConnections) {
    super();
    this.actionName = ts("p_do_action_outer_mod", "Modifying outer walls");
    this.fromWalls = fromWalls;
    this.toWalls = toWalls;
    this.d3Devs = d3Devs;
    this.groups = groups;
    this.matSaveState = matSaveState;
    this.serialConnections = serialConnections;
  }
  execute(callback) {
    const thisVar = this;
    saveOuterWalls(this.toWalls, function () {
      PlannerGlobals.wallSegmentation.recalcPreserveSave(thisVar.matSaveState, true);
      new EntityPlacerBuilder()
      .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
      .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    var thisVar = this;
    saveOuterWalls(this.fromWalls, function () {
      new EntityPlacerBuilder()
      .setD3Devs(thisVar.d3Devs)
      .setGroups(thisVar.groups)
      .setSerialConnections(thisVar.serialConnections)
      .setMatSaveState(thisVar.matSaveState)
      .run()
      .done(function () { callIfFn(callback, true); })
      .fail(function () { callIfFn(callback, false); });
    }, function () {
      callIfFn(callback, false);
    });
  }
  deviceIdChanged(from, to) {
    var thisVar = this;

    this.groups.forEach(function (grp) {
      grp.deviceIds.forEach(function (id, idx) {
        if (thisVar.equalAsString(id, from)) {
          grp.deviceIds[idx] = to;
        }
      });
    });

    plannerHistoryHelper.updateD3DevicesDevIds(from, to, this.d3Devs);
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.getMeasures());
  }
  serialIdChanged(from, to) {
    plannerHistoryHelper.updateD3DevicesSerialIds(from, to, this.d3Devs);
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.getMeasures());
    plannerHistoryHelper.updateSerialIdInConnections(from, to, this.serialConnections);
  }
  serialConnectionIdChanged(from, to) {
    plannerHistoryHelper.updateSerialConnectionId(from, to, this.serialConnections);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.getMeasures());
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.getMeasures());
  }
  roomIdChanged(from, to) {
    plannerHistoryHelper.updateMatStateRoomId(from, to, this.matSaveState);
  }
  getMeasures() {
    var measures = [];
    this.d3Devs.forEach(function (d3d) {
      measures = measures.concat(d3d.removedMeasures || []);
      d3d.devices.forEach(function (dev) {
        measures = measures.concat(dev.removedDevParams.removedMeasures);
      });
    });
    return measures;
  }
}
export class DeleteOuterWallsAction extends PlannerAction {
  /**
   *
   * @param {PolyPoint[]} outerBorder
   * @param {D3Device[]} d3Devs
   * @param {Group[]} groups
   * @param {SerialConnection[]} serialConnections
   */
  constructor(outerBorder, d3Devs, groups, matSaveState, serialConnections) {
    super();
    this.actionName = ts("p_do_action_outer_del", "Deleting outer walls");
    this.outerBorder = outerBorder;
    this.d3Devs = d3Devs;
    this.groups = groups;
    this.matSaveState = matSaveState;
    this.serialConnections = serialConnections;
  }
  execute(callback) {
    /* // TODO: REWORK
    return callIfFn(callback, true); */

    const thisVar = this;
    deleteOuterWalls(function () {
      redrawRooms();
      redrawDevices();
      PlannerGlobals.wallSegmentation.recalcPreserveSave(thisVar.matSaveState, true);
      new EntityPlacerBuilder()
      .setMatSaveState(PlannerGlobals.wallSegmentation.getSaveDataV2())
      .run().then(() => callIfFn(callback, true)).catch(() => callIfFn(callback, false));
      //            callIfFn(callback, true);
    }, function () {
      callIfFn(callback, false);
    });
  }
  undo(callback) {
    /* // TODO: REWORK
    return callIfFn(callback, true); */

    var thisVar = this;
    saveOuterWalls(this.outerBorder, function () {
      new EntityPlacerBuilder()
      /* .setD3Devs(thisVar.d3Devs) */
      .setGroups(thisVar.groups)
      .setSerialConnections(thisVar.serialConnections)
      .setMatSaveState(thisVar.matSaveState)
      .run()
      .done(function () { callIfFn(callback, true); })
      .fail(function () { callIfFn(callback, false); });
    }, function () {
      callIfFn(callback, false);
    });
  }
  deviceIdChanged(from, to) {
    var thisVar = this;

    this.groups.forEach(function (grp) {
      grp.deviceIds.forEach(function (id, idx) {
        if (thisVar.equalAsString(id, from)) {
          grp.deviceIds[idx] = to;
        }
      });
    });

    plannerHistoryHelper.updateD3DevicesDevIds(from, to, this.d3Devs);
    plannerHistoryHelper.updateMeasurementDeviceIds(from, to, this.getMeasures());
  }
  serialIdChanged(from, to) {
    plannerHistoryHelper.updateD3DevicesSerialIds(from, to, this.d3Devs);
    plannerHistoryHelper.updateMeasurementSerialIds(from, to, this.getMeasures());
    plannerHistoryHelper.updateSerialIdInConnections(from, to, this.serialConnections);
  }
  serialConnectionIdChanged(from, to) {
    plannerHistoryHelper.updateSerialConnectionId(from, to, this.serialConnections);
  }
  wallModIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallModIds(from, to, this.getMeasures());
  }
  wallIdChanged(from, to) {
    plannerHistoryHelper.updateMeasurementWallIds(from, to, this.getMeasures());
  }
  roomIdChanged(from, to) {
    plannerHistoryHelper.updateMatStateRoomId(from, to, this.matSaveState);
  }
  getMeasures() {
    var measures = [];
    this.d3Devs.forEach(function (d3d) {
      measures = measures.concat(d3d.removedMeasures || []);
      d3d.devices.forEach(function (dev) {
        measures = measures.concat(dev.removedDevParams.removedMeasures);
      });
    });
    return measures;
  }
}
/* OUTER WALL END */
